import gql from "graphql-tag";

export const BUILD_PROFILE = gql`
  mutation insert_business_profile_one($data: business_profile_insert_input!) {
    insert_business_profile_one(
      object: $data
      on_conflict: {
        constraint: business_profile_user_id_key
        update_columns: [abn, location_text, description, name, mobile_number]
      }
    ) {
      id
    }
  }
`;
